import request from '@/utils/request'

export default {
    // 添加店铺
    add (params) {
        return request.post('/platformshop/shops/addShop', params)
    },
    // 编辑店铺
    edit (params) {
        return request.post('/platformshop/shops/editShop', params)
    },
    // 获得店铺详情
    getDetail (params) {
        return request.post('/platformshop/shops/getShopDetail', params)
    },
    // 获得店铺详情(本店)
    getShopInfo (params) {
        return request.post('/platformshop/shops/getShopInfo', params)
    },
    // 修改店铺详情(本店)
    updateShopInfo (params) {
        return request.post('/platformshop/shops/updateShopInfo', params)
    },
    // 列表字段列表
    getColumns () {
        return request.post('base/baseTools/getTablesDefine', {module_name: 'platformshop', tabel_name: 'shops', get_type: 'shop'})
    }, 
    // 设置店铺默认
    setShopDefault (params) {
        return request.post('/platformshop/shops/setShopDefault', params)
    },
    // 删除店铺(只删除店铺)
    del (params) {
        return request.post('/platformshop/shops/del', params)
    },
    // 删除店铺(删除仓库,员工，商品，库存等等)
    delShop (params) {
        return request.post('/platformshop/shops/delShop', params)
    },
    // 店铺列表
    getList (params) {
        return request.post('/platformshop/shops/getList', params)
    },
    // 统计店铺
    getCount (params) {
        return request.post('/platformshop/shops/getCount', params)
    },
    // 添加账号
    addAccount (params) {
        return request.post('/platformshop/seller/addSeller', params)
    },
    // 编辑账号
    editAccount (params) {
        return request.post('/platformshop/seller/editSeller', params)
    },
    // 获得账号
    getAccountDetail (params) {
        return request.post('/platformshop/seller/getDetail', params)
    },
    // 删除账号
    delAccount (params) {
        return request.post('/platformshop/seller/del', params)
    },
    // 获得账号列表
    getAccountList (params) {
        return request.post('/platformshop/seller/getList', params)
    },
    // 列表账号字段列表
    getAccountColumns () {
        return request.post('base/baseTools/getTablesDefine', {module_name: 'platformshop', tabel_name: 'seller', get_type: 'shop'})
    }, 
    // 获得账号统计
    getAccountCount (params) {
        return request.post('/platformshop/seller/getCount', params)
    },
    // 获得账号角色权限
    getAccountPermission (params) {
        return request.post('/platformshop/seller/getPermission')
    },
    // 获取角色列表
    getRolesList () {
        return request.post('/platformshop/roles/getList')
    },
    // 获取商户权限列表
    getRolesDetail (params) {
        return request.post('/platformshop/roles/getDetail', params)
    },
    postRolesAdd (params) {
        return request.post('/platformshop/roles/postAdd', params)
    },
    postRolesModify (params) {
        return request.post('/platformshop/roles/postModify', params)
    },
    postDeleteRoles (params) {
        return request.post('/platformshop/roles/postDelete', params) 
    }
}



// WEBPACK FOOTER //
// ./src/api/shop.js